import { SgdfRoundCheckbox } from './RoundCheckbox.js';
window.customElements.define('sgdf-round-checkbox', SgdfRoundCheckbox);
//# sourceMappingURL=sgdf-round-checkbox.js.map